import React, {Component} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import styled from "styled-components"
import {connect} from "@irati/store"

import {H2} from "@irati/ui/src/Typography/Heading"
import IconText from "@irati/ui/src/IconText"
import {ValidationButton} from "@irati/ui/src/FormItem"
import Button, {IconTypes, TextButton} from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import Loading from "@irati/ui/src/Loading"
import id from "@irati/utils/id"
import {validatedScreen} from "@irati/utils/validation"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"

import RewardImg from "../../Reward"
import CustomReward, {CUSTOM_REWARD} from "./Reward/CustomReward"

const RewardContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${padding.base};
  ${Button} {
    width: 46%;
  }
`

const RewardButton = styled(TextButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${padding.tiny};
  ${({selected}) => selected && `
    background-color: ${({theme}) => theme.colors.greys.lightest}
  `}
`

const HintContainer = styled.div`
  margin-top: ${padding.small}
`

class ChallengeReward extends Component {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    load: PropTypes.object.isRequired,
    rewards: PropTypes.array.isRequired,
    intl: PropTypes.object.isRequired
  }

  static defaultProps = {
    id: "selectReward"
  }

  constructor(props) {
    super(props)
    const {reward} = props.poll
    this.state = {
      selected: reward,
      customReward: get(reward, "isCustom", false) ? reward.desc : null
    }
  }

  getTeams = () => {
    const {teams} = this.props.poll
    return teams.join(", ")
  }

  handleSave = () => {
    const {poll, onChange, onSubmit} = this.props
    const {customReward} = this.state
    let {selected} = this.state

    if (selected && selected.isCustom) {
      selected = {...selected, desc: customReward}
    }

    onChange(poll, "reward", selected)
    onSubmit()
  }

  handleNone = () => {
    this.setState({selected: null}, () => {
      this.handleSave()
    })
  }

  handleCustomReward = (customReward) => {
    this.setState({customReward})
  }

  isSelected = (reward) => {
    const {selected} = this.state
    if (!selected) {
      return false
    }

    if (selected.isCustom && reward.isCustom) {
      return true
    }

    return selected === reward
  }

  getHintText = (isCustom) => {
    if (isCustom) {
      return <FormattedMessage id="recognition.popup.shared.reward.hintText.isCustom" />
    }
    return <FormattedMessage id="recognition.popup.shared.reward.hintText.isNotCustom" />
  }

  render() {
    const {load, rewards, intl} = this.props
    const {customReward, selected} = this.state

    const isCustom = get(selected, "isCustom")

    return (
      <div>
        <H2 small className="text-center">
          <FormattedMessage id="recognition.popup.shared.reward.header" />
        </H2>
        <Loading load={load}>
          <RewardContainer>
            {[...rewards, CUSTOM_REWARD(intl)].map((reward, i) =>
              <RewardButton
                key={i}
                id={id(`button_${i}`, this.props)}
                selected={this.isSelected(reward)}
                onClick={() => this.setState({selected: reward})}>
                <RewardImg src={reward.href} alt={reward.alt} />
                {reward.desc}
              </RewardButton>
            )}
          </RewardContainer>
        </Loading>
        {isCustom &&
          <RewardContainer>
            <CustomReward className="flush--botom" value={customReward} onChange={this.handleCustomReward} />
          </RewardContainer>
        }
        <HintContainer>
          <IconText icon={IconTypes.info}>{this.getHintText(isCustom)}</IconText>
        </HintContainer>
        <ButtonContainer>
          <Button
            id={id("none", this.props)}
            onClick={this.handleNone}>
            <FormattedMessage id="recognition.popup.shared.reward.noReward" />
          </Button>
          <ValidationButton
            id={id("save", this.props)}
            primary
            onClick={this.handleSave}>
            <FormattedMessage id="recognition.popup.shared.reward.save" />
          </ValidationButton>
        </ButtonContainer>
      </div>
    )
  }
}

const mapStateToProps = ({recognition}) => {
  return {
    rewards: recognition.rewards,
    load: recognition.load
  }
}

export default injectIntl(validatedScreen(connect(mapStateToProps)(ChallengeReward), "ChallengeReward"))
